/**
 * Sync TrafficPulse per-path AI flag into Voluum `autoOptimized` + automation fields.
 *
 * Voluum's per-path `autoOptimized` corresponds to **offer / lander weight optimization**
 * for that path. Set-level "Traffic distribution AI" lives on
 * `flow.automationConfiguration` and `group.automationConfiguration`, not on the path.
 *
 * The legacy `__tpPathsDistributionAi` key is preserved for back-compat with stored
 * drafts but is no longer wired into `autoOptimized`.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { VoluumPathUpdate } from '@trafficpulse/shared';

import {
  TP_OFFERS_CALCULATION_METHOD_KEY,
  TP_OFFERS_LANDERS_AI_KEY,
  readTpCalc,
  readTpFlag,
} from './path-ai-read';

function stripVoluumAutomationWhenOff(p: VoluumPathUpdate): void {
  delete p.autoOptimizationMode;
  delete p.calculationMethod;
}

/**
 * Applies `__tpOffersLandersAi` onto Voluum's per-path `autoOptimized`.
 * Call before deleting TP keys on PUT and from `syncPathAutoOptimized` for draft parity.
 */
export function applyTpSplitToVoluumAutomation(p: VoluumPathUpdate): void {
  const offers = readTpFlag(p, TP_OFFERS_LANDERS_AI_KEY);
  if (offers === undefined) return;
  p.autoOptimized = offers;
  if (!offers) stripVoluumAutomationWhenOff(p);
}

export function syncPathAutoOptimized(p: VoluumPathUpdate): void {
  applyTpSplitToVoluumAutomation(p);
}

export function syncPathCalculationMethod(p: VoluumPathUpdate): void {
  if (!p.autoOptimized) return;
  const offersM = readTpCalc(p, TP_OFFERS_CALCULATION_METHOD_KEY);
  if (offersM !== undefined) p.calculationMethod = offersM;
}
